export default {
  "about": "हमारे बारे में",
  "about_title": "हमारे बारे में",
  "access_secret": "एक्सेस सीक्रेट",
  "access_token": "एक्सेस टोकन",
  "accessibility_animations": "एनिमेशन",
  "accessibility_contrast": "विपरीतता",
  "accessibility_font_size": "फ़ॉन्ट आकार",
  "accessibility_title": "सुगमता",
  "actions": "क्रियाएँ",
  "active": "सक्रिय",
  "active_ads": "सक्रिय विज्ञापन",
  "active_campaigns": "सक्रिय अभियान",
  "ad_code_placeholder": "<script>...</script> या AdSense स्लॉट कोड",
  "ad_format": "विज्ञापन प्रारूप",
  "ad_formats": "विज्ञापन प्रारूप",
  "ad_management": "विज्ञापन प्रबंधन",
  "ad_position_settings": "विज्ञापन स्थिति सेटिंग्स",
  "ad_price_list": "विज्ञापन मूल्य सूची",
  "ad_pricing_formats_campaigns": "मूल्य निर्धारण, प्रारूप, अभियान और ट्रैकिंग",
  "add": "जोड़ें",
  "add_api_keys": "कॉन्फ़िगर टैब में API कुंजियाँ जोड़ें",
  "address": "पता",
  "admin": "एडमिन",
  "adminPanel": "प्रशासनिक पैनल",
  "admin_ab_testing_title": "ए/बी परीक्षण",
  "admin_accent": "उभरता",
  "admin_accent_color": "उभरता रंग",
  "admin_action": "क्रिया",
  "admin_activate": "सक्रिय करें",
  "admin_active_feeds": "सक्रिय फीड्स",
  "admin_active_label": "सक्रिय",
  "admin_active_now": "अभी सक्रिय",
  "admin_active_subscribers": "सक्रिय ग्राहक",
  "admin_ad_performance": "विज्ञापन प्रदर्शन",
  "admin_add_feed": "फीड जोड़ें",
  "admin_add_tag": "टैग जोड़ें",
  "admin_admins": "एडमिन्स",
  "admin_advertisements": "विज्ञापन",
  "admin_advertiser_email": "विज्ञापनदाता ईमेल",
  "admin_advertiser_name": "विज्ञापनदाता का नाम",
  "admin_affiliate_links": "संबद्ध लिंक",
  "admin_ai_content_title": "एआई सामग्री प्रसंस्करण",
  "admin_ai_prompt_settings": "एआई प्रॉम्प्ट और मॉडल सेटिंग्स",
  "admin_analytics_title": "विश्लेषिकी",
  "admin_api_latency": "एपीआई विलंबता",
  "admin_api_server": "API सर्वर",
  "admin_article_actions": "क्रियाएं",
  "admin_article_category": "श्रेणी",
  "admin_article_published": "प्रकाशित",
  "admin_article_selector": "लेख चयनकर्ता (CSS, जैसे article.news)",
  "admin_article_views": "दृश्य",
  "admin_articles_count": "लेख",
  "admin_articles_title": "लेख",
  "admin_author_change_failed": "लेखक परिवर्तन विफल।",
  "admin_authors_title": "लेखक",
  "admin_auto": "ऑटो",
  "admin_auto_save_draft": "मसौदे के रूप में स्वचालित बचत",
  "admin_avg_seo_score": "औसत एसईओ स्कोर",
  "admin_bio": "जीवनी",
  "admin_blog_manage": "समृद्ध सामग्री संपादक के साथ ब्लॉग पोस्ट प्रबंधित करें",
  "admin_blog_title": "ब्लॉग",
  "admin_brand_theme": "ब्रांड और थीम",
  "admin_branding_desc": "साइट उपस्थिति अनुकूलित करें (केवल सिस्टम एडमिन)",
  "admin_branding_title": "रीब्रांडिंग मॉड्यूल",
  "admin_breaking_ticker": "ताज़ा समाचार टिकर",
  "admin_browser": "ब्राउज़र",
  "admin_browsers": "ब्राउज़र",
  "admin_bug_reports": "बग रिपोर्ट",
  "admin_bulk_delete_failed": "बड़े पैमाने पर हटाना विफल।",
  "admin_bulk_operations": "बड़े पैमाने पर संचालन",
  "admin_categories_grid": "श्रेणियाँ ग्रिड",
  "admin_choose_gallery": "गैलरी से चुनें",
  "admin_churn_prediction": "चर्न पूर्वानुमान",
  "admin_classic_portal": "क्लासिक न्यूज़ पोर्टल",
  "admin_classifieds": "वर्गीकृत",
  "admin_clear_log": "लॉग साफ़ करें",
  "admin_click_button": "बटन पर क्लिक करें",
  "admin_collection_stats": "संग्रह आँकड़े",
  "admin_color_scheme": "रंग योजना",
  "admin_columnist": "स्तंभकार",
  "admin_comments": "टिप्पणियाँ",
  "admin_competitor_monitoring": "प्रतियोगी की निगरानी",
  "admin_confirm_action": "क्या आप निश्चित हैं?",
  "admin_content_calendar_title": "सामग्री कैलेंडर",
  "admin_content_filter": "सामग्री फ़िल्टर शर्तें",
  "admin_content_stats": "सामग्री आँकड़े",
  "admin_contributor": "योगदानकर्ता",
  "admin_coordinates": "निर्देशांक",
  "admin_copy_ip": "आईपी पता कॉपी करें",
  "admin_copy_text": "कॉपी",
  "admin_core_services": "कोर सेवाएं",
  "admin_countries": "देश",
  "admin_cpc": "सीपीसी (EUR)",
  "admin_crawl_now": "अभी क्रॉल करें",
  "admin_create_author": "लेखक बनाएं",
  "admin_create_manage_promo": "प्रोमोशनल कोड बनाएं और प्रबंधित करें",
  "admin_create_voucher": "वाउचर बनाएं",
  "admin_custom_meta": "कस्टम मेटा",
  "admin_dashboard_title": "डैशबोर्ड",
  "admin_database": "डेटाबेस",
  "admin_db_backup": "डेटाबेस बैकअप",
  "admin_db_latency": "डीबी विलंबता",
  "admin_db_name": "डाटाबेस का नाम",
  "admin_db_size": "डीबी आकार",
  "admin_default": "डिफ़ॉल्ट",
  "admin_default_language": "डिफ़ॉल्ट भाषा",
  "admin_device": "डिवाइस",
  "admin_devices": "डिवाइस",
  "admin_discount": "छूट",
  "admin_disk_usage": "डिस्क उपयोग",
  "admin_docs_api_ref": "एपीआई संदर्भ",
  "admin_docs_download_pdf": "पीडीएफ डाउनलोड करें",
  "admin_docs_faq": "सामान्य प्रश्न",
  "admin_docs_getting_started": "प्रारंभ हो रहा है",
  "admin_docs_implemented": "लागू",
  "admin_docs_no_pages": "अभी कोई दस्तावेज़ पृष्ठ नहीं",
  "admin_docs_order": "क्रम",
  "admin_docs_title": "दस्तावेज़",
  "admin_doktor_earnings": "Doktor कमाई",
  "admin_draft_articles": "मसौदा लेख",
  "admin_dynamic_pricing": "गतिशील मूल्य निर्धारण",
  "admin_edit_in_cms": "सीएमएस में संपादित करें",
  "admin_editor_role": "संपादक",
  "admin_export_csv": "CSV निर्यात करें",
  "admin_favicon": "फेविकॉन",
  "admin_feed_crawler": "फीड क्रॉलर",
  "admin_feed_name": "फीड नाम",
  "admin_feed_url": "फीड यूआरएल",
  "admin_feeds_title": "आरएसएस फीड्स",
  "admin_file": "फ़ाइल",
  "admin_fixed_amount": "निश्चित राशि",
  "admin_frozen": "रुका हुआ",
  "admin_full_name": "पूरा नाम",
  "admin_general": "सामान्य",
  "admin_google_search_console": "गूगल सर्च कंसोल",
  "admin_grade": "ग्रेड",
  "admin_health_title": "स्वास्थ्य जाँच",
  "admin_high_leads": "उच्च मूल्य लीड्स",
  "admin_import_title": "Croatia Times आयात मंच",
  "admin_index_now": "IndexNow",
  "admin_integrations": "एकीकरण",
  "admin_job_postings": "नौकरी पोस्टिंग",
  "admin_joined": "शामिल हुए",
  "admin_keywords": "कीवर्ड्स",
  "admin_landing_title": "लैंडिंग पेज",
  "admin_last_submissions": "अंतिम प्रस्तुतियाँ",
  "admin_live_analytics": "लाइव एनालिटिक्स",
  "admin_live_analytics_title": "लाइव विश्लेषिकी",
  "admin_llm_model": "एलएलएम मॉडल",
  "admin_manage_feeds": "फीड प्रबंधित करें",
  "admin_mass_management": "बड़े पैमाने पर लेख प्रबंधन",
  "admin_max_articles": "अधिकतम लेख",
  "admin_media_storage": "मीडिया भंडारण",
  "admin_memory": "मेमोरी",
  "admin_menu_manager": "मेनू प्रबंधक",
  "admin_meta_description": "मेटा विवरण",
  "admin_monetization_title": "मुद्रीकरण डैशबोर्ड",
  "admin_mysql_db": "MySQL डेटाबेस",
  "admin_mysql_host": "MySQL होस्ट",
  "admin_nav_ab_testing": "ए/बी परीक्षण",
  "admin_nav_ads": "विज्ञापन प्रबंधन",
  "admin_nav_ads_report": "विज्ञापन रिपोर्ट",
  "admin_nav_adsense": "AdSense सेटिंग्स",
  "admin_nav_advanced_analytics": "उन्नत एनालिटिक्स",
  "admin_nav_affiliates": "संबद्ध लिंक",
  "admin_nav_ai_content": "एआई सामग्री प्रसंस्करण",
  "admin_nav_amp": "एएमपी और Google डिस्कवर",
  "admin_nav_analytics": "एनालिटिक्स",
  "admin_nav_analytics_ai": "एनालिटिक्स & एआई",
  "admin_nav_articles": "लेख",
  "admin_nav_audit_log": "ऑडिट लॉग",
  "admin_nav_authors": "लेखक",
  "admin_nav_blog": "ब्लॉग",
  "admin_nav_branding": "रीब्रांडिंग",
  "admin_nav_breaking_news": "ब्रेकिंग / फ्लैश समाचार",
  "admin_nav_bulk_operations": "थोक संचालन",
  "admin_nav_categories": "श्रेणियाँ",
  "admin_nav_chat_sessions": "चैट सत्र",
  "admin_nav_churn_prediction": "चर्न पूर्वानुमान",
  "admin_nav_classifieds": "वर्गीकृत",
  "admin_nav_comments": "टिप्पणियाँ",
  "admin_nav_competitor_monitoring": "प्रतिस्पर्धी निगरानी",
  "admin_nav_content": "सामग्री",
  "admin_nav_content_calendar": "सामग्री कैलेंडर",
  "admin_nav_county_map": "काउंटी मानचित्र",
  "admin_nav_crypto": "क्रिप्टो विजेट",
  "admin_nav_dashboard": "डैशबोर्ड",
  "admin_nav_db_backup": "डेटाबेस",
  "admin_nav_docs": "दस्तावेज़ीकरण",
  "admin_nav_doktor_earnings": "डॉक्टर आय",
  "admin_nav_duplicate_detection": "प्रतिलिपि पहचान",
  "admin_nav_editorial": "संपादकीय",
  "admin_nav_editorial_workflow": "संपादकीय वर्कफ़्लो",
  "admin_nav_email_campaigns": "ईमेल अभियान",
  "admin_nav_feeds": "आरएसएस फ़ीड्स",
  "admin_nav_finance": "वित्त",
  "admin_nav_health": "प्रणाली स्वास्थ्य",
  "admin_nav_heatmaps": "पठन हीटमैप",
  "admin_nav_import": "आयात",
  "admin_nav_invoices": "चालान",
  "admin_nav_job_ads": "नौकरी विज्ञापन",
  "admin_nav_landing_pages": "लैंडिंग पेज",
  "admin_nav_live_analytics": "लाइव एनालिटिक्स",
  "admin_nav_management": "प्रबंधन",
  "admin_nav_marketing": "मार्केटिंग",
  "admin_nav_media": "मीडिया",
  "admin_nav_menu_manager": "मेनू प्रबंधक",
  "admin_nav_micropayments": "सूक्ष्म-भुगतान",
  "admin_nav_monetization": "मुद्रीकरण",
  "admin_nav_newsletter": "न्यूज़लेटर",
  "admin_nav_newsletter_digest": "न्यूज़लेटर डाइजेस्ट",
  "admin_nav_pages": "पृष्ठ",
  "admin_nav_payments": "भुगतान",
  "admin_nav_performance_forecast": "प्रदर्शन पूर्वानुमान",
  "admin_nav_photo_verification": "फोटो सत्यापन",
  "admin_nav_portal_toggle": "पोर्टल प्रबंधन",
  "admin_nav_portals": "पोर्टल्स",
  "admin_nav_pricing": "मूल्य निर्धारण",
  "admin_nav_promo_codes": "प्रोमो कोड",
  "admin_nav_push_notifications": "पुश सूचनाएं",
  "admin_nav_quizzes": "प्रश्नोत्तरी",
  "admin_nav_recommendations": "सामग्री सिफारिशें",
  "admin_nav_reports": "सामग्री रिपोर्ट",
  "admin_nav_sanitization": "सामग्री शोधन",
  "admin_nav_scheduler": "सामग्री अनुसूचक",
  "admin_nav_security": "सुरक्षा",
  "admin_nav_seo_dashboard": "एसईओ डैशबोर्ड",
  "admin_nav_seo_distribution": "एसईओ और वितरण",
  "admin_nav_series": "लेख श्रृंखला",
  "admin_nav_settings": "सेटिंग्स",
  "admin_nav_social": "सोशल मीडिया",
  "admin_nav_social_scheduler": "सोशल शेड्यूलर",
  "admin_nav_sponsored": "प्रायोजित",
  "admin_nav_sponsored_marketplace": "प्रायोजित बाजार",
  "admin_nav_subscriptions": "सदस्यताएँ",
  "admin_nav_surveys": "सर्वेक्षण",
  "admin_nav_syndication": "सिंडिकेशन एपीआई",
  "admin_nav_system": "प्रणाली",
  "admin_nav_tips": "टिप्स / दान",
  "admin_nav_translations": "अनुवाद",
  "admin_nav_ugc_review": "नागरिक सामग्री",
  "admin_nav_users": "उपयोगकर्ता",
  "admin_nav_users_subscriptions": "उपयोगकर्ता और सदस्यताएँ",
  "admin_nav_versioning": "संस्करण इतिहास",
  "admin_nav_vibeposao": "Times Posao पोर्टल",
  "admin_nav_vouchers": "वाउचर / छूट",
  "admin_nav_widgets": "विजेट / कैटलॉग",
  "admin_new_author_name": "नया लेखक नाम...",
  "admin_new_post": "नई पोस्ट",
  "admin_no_data": "कोई डेटा उपलब्ध नहीं",
  "admin_no_icon": "कोई चिह्न नहीं",
  "admin_no_logo": "कोई लोगो नहीं",
  "admin_no_pending_reports": "कोई लंबित रिपोर्ट नहीं",
  "admin_no_published_articles": "कोई प्रकाशित लेख नहीं मिले",
  "admin_password_field": "पासवर्ड",
  "admin_performance_forecast": "प्रदर्शन पूर्वानुमान",
  "admin_photo_verification": "फोटो सत्यापन",
  "admin_plan": "योजना",
  "admin_platform_audit": "प्लेटफ़ॉर्म ऑडिट",
  "admin_portal_toggle": "पोर्टल प्रबंधन",
  "admin_premium_users": "प्रीमियम उपयोगकर्ता",
  "admin_primary": "प्राथमिक",
  "admin_published_articles": "प्रकाशित लेख",
  "admin_published_today": "आज प्रकाशित",
  "admin_quick_actions": "त्वरित कार्य",
  "admin_recent_articles": "हाल के लेख",
  "admin_role_change_failed": "भूमिका अपडेट करने में विफल।",
  "admin_search_placeholder": "एडमिन खोजें...",
  "admin_secondary": "माध्यमिक",
  "admin_seo_desc": "सामग्री अनुकूलन, GSC और साइटमैप प्रबंधन",
  "admin_seo_title": "एसईओ डैशबोर्ड",
  "admin_service_requests": "सेवा अनुरोध",
  "admin_set_category": "श्रेणी निर्धारित करें",
  "admin_set_featured": "विशेष रुप से प्रदर्शित सेट करें",
  "admin_settings_saved": "सेटिंग्स सहेजी गई",
  "admin_settings_title": "सेटिंग्स",
  "admin_short_desc": "संक्षिप्त विवरण",
  "admin_site_identity": "साइट आइडेंटिटी",
  "admin_site_logo": "साइट लोगो",
  "admin_site_settings": "साइट सेटिंग्स",
  "admin_sponsored_marketplace": "प्रायोजित मार्केटप्लेस",
  "admin_sponsored_title": "प्रायोजित लेख",
  "admin_surveys_title": "सर्वेक्षण",
  "admin_system_status": "सिस्टम स्थिति",
  "admin_table_header_actions": "क्रियाएँ",
  "admin_table_header_date": "तारीख",
  "admin_table_header_email": "ईमेल",
  "admin_table_header_name": "नाम",
  "admin_table_header_status": "स्थिति",
  "admin_thumbnail_settings_saved": "थंबनेल सेटिंग्स सहेजी गईं",
  "admin_top_articles_views": "दृश्यों द्वारा शीर्ष लेख",
  "admin_total_articles": "कुल लेख",
  "admin_total_users": "कुल उपयोगकर्ता",
  "admin_total_views": "कुल दृश्य",
  "admin_ugc_review": "यूजीसी समीक्षा",
  "admin_username": "उपयोगकर्ता नाम",
  "admin_users_title": "उपयोगकर्ता",
  "admin_version_history": "संस्करण इतिहास",
  "admin_view_health_report": "पूर्ण स्वास्थ्य रिपोर्ट देखें",
  "admin_write_new_article": "नया लेख लिखें",
  "adsense_client_id": "AdSense क्लाइंट आईडी",
  "adsense_enable_disable": "सभी स्वचालित विज्ञापन सेवा सक्षम/अक्षम करें",
  "adsense_global_toggle": "AdSense वैश्विक टॉगल",
  "adsense_script_code": "AdSense स्क्रिप्ट कोड",
  "adsense_settings": "AdSense और विज्ञापन स्थिति",
  "advertise_contact_sales": "बिक्री से संपर्क करें",
  "advertise_get_started": "शुरू करें",
  "advertise_reach_audience": "हमारे दर्शकों तक पहुंचें",
  "advertise_title": "हमारे साथ विज्ञापन करें",
  "advertiser": "विज्ञापनदाता",
  "advertiser_analytics": "विज्ञापनदाता विश्लेषिकी",
  "advertiser_email": "विज्ञापनदाता ईमेल",
  "advertising": "विज्ञापन",
  "advertising_cookies": "विज्ञापन कुकीज़",
  "affiliate_title": "संबद्ध कार्यक्रम",
  "ago": "पहले",
  "ai_image_prompt": "एआई छवि प्रांप्ट",
  "all": "सभी",
  "all_categories": "सभी श्रेणियाँ",
  "all_jobs": "सभी नौकरियां",
  "all_rights": "सर्वाधिकार सुरक्षित",
  "all_status": "सभी स्थिति",
  "all_types": "सभी प्रकार",
  "alpha": "अल्फा",
  "alreadyHaveAccount": "पहले से ही एक खाता है?",
  "already_have_account": "पहले से खाता है?",
  "analytics": "विश्लेषिकी",
  "analytics_cookies": "विश्लेषणात्मक कुकीज़",
  "api_key": "API कुंजी",
  "api_secret": "API सीक्रेट",
  "applications": "आवेदन",
  "apply": "लागू करें",
  "apply_now": "अभी आवेदन करें",
  "approve": "अनुमोदन करें",
  "approved": "अनुमोदित",
  "archive": "संग्रहित करें",
  "archived": "संग्रहीत",
  "article_content": "लेख सामग्री",
  "article_title": "लेख का शीर्षक...",
  "article_views": "दृश्य",
  "author": "लेखक",
  "auto_posting": "स्वतः पोस्ट करना और सोशल इंटिग्रेशन्स",
  "auto_share_articles": "संयोजित प्लेटफ़ॉर्म पर प्रकाशित लेख स्वतः साझा करें",
  "avg_ctr": "औसत CTR",
  "back": "वापस",
  "basic": "बेसिक",
  "be_respectful": "अन्य उपयोगकर्ताओं और लेखों के विषयों के प्रति सम्मानजनक और सभ्य रहें",
  "beta": "बीटा",
  "book_ad": "विज्ञापन बुक करें",
  "booking_details": "बुकिंग विवरण",
  "breaking": "ब्रेकिंग न्यूज़",
  "bug_description": "बग विवरण",
  "business": "व्यापार",
  "business_account_id": "व्यापार खाता आईडी",
  "buyer": "खरीददार",
  "campaign_details": "अभियान विवरण",
  "campaigns": "अभियान",
  "cancel": "रद्द करें",
  "caption": "कैप्शन",
  "categories": "श्रेणियां",
  "category": "श्रेणी",
  "category_distribution": "श्रेणी वितरण",
  "category_push_subscribers": "श्रेणी पुश सब्सक्राइबर",
  "chatbot_placeholder": "संदेश लिखें...",
  "chatbot_send": "भेजें",
  "chatbot_title": "चैट सहायक",
  "choose_plan": "अपना प्लान चुनें",
  "city": "शहर",
  "classifieds": "विज्ञापन",
  "classifieds_title": "वर्गीकृत",
  "clear": "हटाएँ",
  "click_rate": "क्लिक दर",
  "click_url": "क्लिक URL (गंतव्य)",
  "clicks": "क्लिक",
  "client_id": "क्लाइंट आईडी",
  "client_secret": "क्लाइंट सीक्रेट",
  "close": "बंद करें",
  "code": "कोड",
  "commenting_rules": "टिप्पणी नियम",
  "comments": "टिप्पणियां",
  "companies": "कंपनियां",
  "company": "कंपनी",
  "compose_social_post": "सोशल पोस्ट तैयार करें",
  "configure": "कॉन्फ़िगर करें",
  "configure_position": "प्रत्येक स्थान को कस्टम बैनर छवि या विज्ञापन कोड के साथ कॉन्फ़िगर करें",
  "confirm": "पुष्टि करें",
  "confirm_delete": "क्या आप वाकई हटाना चाहते हैं?",
  "confirm_password": "पासवर्ड की पुष्टि करें",
  "congratulations": "बधाई हो",
  "contact": "संपर्क",
  "contact_title": "संपर्क",
  "contact_us": "हमसे संपर्क करें",
  "content": "सामग्री",
  "cookies": "कुकीज़",
  "cookies_title": "कुकी नीति",
  "copy": "कॉपी करें",
  "copyright": "प्रतिलिप्यधिकार",
  "copyright_notice": "कॉपीराइट",
  "count": "गणना",
  "country": "देश",
  "cpm": "CPM",
  "create": "बनाएं",
  "create_first_ad": "अपना पहला विज्ञापन बनाएँ",
  "crypto_change_24h": "24 घंटे में बदलाव",
  "crypto_market_cap": "बाज़ार पूंजीकरण",
  "crypto_price": "कीमत",
  "crypto_widget_title": "क्रिप्टो",
  "ctr": "CTR",
  "culture": "संस्कृति",
  "current_plan": "वर्तमान प्लान",
  "custom_ad_code": "कस्टम विज्ञापन कोड",
  "custom_banner_url": "कस्टम बैनर URL",
  "custom_range": "कस्टम रेंज",
  "daily_budget": "दैनिक बजट",
  "daily_performance": "दैनिक प्रदर्शन",
  "dark_mode": "डार्क मोड",
  "data_viz_title": "डेटा विज़ुअलाइजेशन",
  "date": "तारीख",
  "dating_add_video": "एक छोटा वीडियो जोड़ें ताकि संभावित मैच आपको बेहतर जान सकें",
  "dating_block": "ब्लॉक",
  "dating_boosts": "बूस्ट्स",
  "dating_city": "शहर",
  "dating_next": "अगला",
  "dating_personality_quiz": "व्यक्तित्व प्रश्नोत्तरी",
  "dating_quiz_completed": "व्यक्तित्व प्रश्नोत्तरी पूरी हुई",
  "dating_users": "उपयोगकर्ता",
  "dating_verify_identity": "सुनिश्चित करें कि आप एक वास्तविक व्यक्ति हैं",
  "dating_voice_message": "वॉइस संदेश",
  "days": "दिन",
  "delete": "हटाएं",
  "delete_failed": "हटाने में विफल।",
  "deleted_successfully": "सफलतापूर्वक हटा दिया गया",
  "deprecated": "अप्रचलित",
  "describe_thumbnail": "थंबनेल छवि का वर्णन करें...",
  "description": "विवरण",
  "deselect_all": "चयन समाप्त करें",
  "desktop": "डेस्कटॉप",
  "details": "विवरण",
  "dimensions": "आयाम",
  "disabled": "निष्क्रिय",
  "dismiss": "खारिज करें",
  "documentation": "दस्तावेज़ीकरण",
  "doktor_add_document": "दस्तावेज़ जोड़ें",
  "doktor_biography": "जीवनी",
  "doktor_birth_date": "जन्म तिथि",
  "doktor_chat": "चैट",
  "doktor_control_date": "नियंत्रण तारीख",
  "doktor_date": "तारीख",
  "doktor_diagnosis": "निदान",
  "doktor_enter_name_specialization": "नाम और कम से कम एक विशेषज्ञता दर्ज करें",
  "doktor_enter_patient_name": "रोगी का नाम दर्ज करें",
  "doktor_license_number": "लाइसेंस संख्या",
  "doktor_panel": "डॉक्टर पैनल",
  "doktor_patient_name": "रोगी का नाम",
  "doktor_text_min_chars": "पाठ में कम से कम 50 वर्ण होने चाहिए",
  "doktor_waiting_room": "प्रतीक्षा कक्ष",
  "dont_have_account": "खाता नहीं है?",
  "download": "डाउनलोड",
  "draft": "मसौदा",
  "duplicate": "प्रतिलिपि बनाएं",
  "duration_days": "अवधि (दिन)",
  "economy": "अर्थव्यवस्था",
  "edit": "संपादित करें",
  "electronics": "इलेक्ट्रॉनिक्स",
  "email": "ईमेल",
  "email_address": "ईमेल पता",
  "email_campaigns": "ईमेल अभियान",
  "email_clicks": "ईमेल क्लिक",
  "email_content": "ईमेल सामग्री...",
  "email_opens": "ईमेल खुला",
  "email_placeholder": "आपका ईमेल",
  "email_subject": "ईमेल विषय",
  "employer": "नियोक्ता",
  "enabled": "सक्रिय",
  "end_date": "समाप्ति तिथि",
  "enter_advertiser_email": "अपना विज्ञापनदाता ईमेल दर्ज करें...",
  "enter_email_to_view": "अपने अभियान प्रदर्शन को देखने के लिए ऊपर अपना विज्ञापनदाता ईमेल दर्ज करें",
  "entertainment": "मनोरंजन",
  "error": "त्रुटि",
  "error_deleting": "हटाने में त्रुटि",
  "error_generating_digest": "डाइजेस्ट उत्पन्न करने में त्रुटि",
  "error_loading": "लोड करने में त्रुटि",
  "error_saving": "सहेजने में त्रुटि",
  "error_saving_settings": "सेटिंग्स सहेजने में त्रुटि",
  "error_sending": "भेजने में त्रुटि",
  "error_uploading": "अपलोड करने में त्रुटि",
  "error_uploading_photo": "फोटो अपलोड करने में विफल",
  "events_calendar": "कार्यक्रम कैलेंडर",
  "excerpt_summary": "अंश / सारांश",
  "experimental": "प्रायोगिक",
  "export": "निर्यात",
  "export_data": "डेटा निर्यात करें",
  "facebook": "फेसबुक",
  "facebook_login_unavailable": "फेसबुक लॉगिन उपलब्ध नहीं है",
  "failed_post_comment": "टिप्पणी पोस्ट करने में विफल।",
  "feature_flags": "फीचर फ्लैग्स",
  "feature_job": "विशेष नौकरी",
  "featured": "विशेष रुप से प्रदर्शित",
  "featured_article": "विशेष लेख",
  "featured_duration": "विशेष अवधि",
  "featured_image": "विशेष छवि",
  "featured_jobs": "विशेष नौकरियां",
  "feedback": "प्रतिक्रिया",
  "filter": "फ़िल्टर",
  "filter_terms_saved": "फिल्टर शर्तें सहेजी गईं!",
  "find_jobs": "नौकरी खोजें",
  "first": "प्रथम",
  "first_process_publish": "पहले लेख को प्रक्रिया और प्रकाशन करें",
  "footer_ai": "यह पोर्टल AI सहायता का उपयोग करता है",
  "footer_ai_notice": "कुछ सामग्री AI सहायत से बनाई गई है - समस्याओं की रिपोर्ट करें",
  "footer_cat_business": "व्यापार",
  "footer_cat_culture": "संस्कृति",
  "footer_cat_health": "स्वास्थ्य",
  "footer_cat_news": "समाचार",
  "footer_cat_politics": "राजनीति",
  "footer_cat_sports": "खेल",
  "footer_cat_technology": "प्रौद्योगिकी",
  "footer_categories": "श्रेणियाँ",
  "footer_copyright": "2026 Liber Nostra d.o.o. सर्वाधिकार सुरक्षित।",
  "footer_description": "Croatia Times आपके लिए विश्वसनीय स्रोत है नवीनतम समाचारों, विस्तृत विश्लेषण और क्रोएशिया और उससे आगे की दिलचस्प कहानियों के लिए।",
  "footer_developed_by": "प्यार के साथ विकसित और बनाए रखा",
  "footer_email_placeholder": "आपका ईमेल पता",
  "footer_here": "यहाँ",
  "footer_hosted_by": "द्वारा होस्ट किया गया",
  "footer_link_about": "हमारे बारे में",
  "footer_link_advertise": "विज्ञापन",
  "footer_link_contact": "संपर्क",
  "footer_link_cookies": "कुकीज़",
  "footer_link_imprint": "इम्प्रिंट",
  "footer_link_privacy": "गोपनीयता नीति",
  "footer_link_submit_news": "समाचार जमा करें",
  "footer_newsletter_text": "हमारे न्यूज़लेटर की सदस्यता लें",
  "footer_quick_links": "त्वरित लिंक",
  "footer_stay_informed": "सूचित रहें",
  "footer_subscribe": "सदस्यता लें",
  "for_you_personalized": "आपकी रुचियों के आधार पर व्यक्तिगत सामग्री",
  "for_you_title": "आपके लिए",
  "forgot_password": "पासवर्ड भूल गए?",
  "free": "मुफ़्त",
  "free_plan": "मुफ़्त",
  "from": "से",
  "full_time": "पूर्णकालिक",
  "general": "सामान्य",
  "goodbye": "अलविदा",
  "hashtags": "हैशटैग्स",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "ऑटो-शेड्यूल सक्रिय",
  "header_forecast": "पूर्वानुमान",
  "header_humidity": "आर्द्रता",
  "header_live": "लाइव",
  "header_portals_label": "पोर्टल",
  "header_weather_humidity": "नमी",
  "header_weather_wind": "हवा",
  "header_wind": "हवा",
  "health": "स्वास्थ्य",
  "hello": "नमस्ते",
  "help": "सहायता",
  "home": "होम",
  "home_podcast_title": "साप्ताहिक टेक राउंडअप: क्रोएशियाई स्टार्टअप्स में AI",
  "home_video_title": "ज़ाग्रेब के अंदर: स्ट्रीट आर्ट डॉक्यूमेंट्री",
  "hours": "घंटे",
  "import": "आयात",
  "impressions": "दृश्य",
  "imprint": "छाप",
  "imprint_title": "इंप्रिंट",
  "inactive": "निष्क्रिय",
  "info": "जानकारी",
  "instagram": "इंस्टाग्राम",
  "invalid_code": "अमान्य कोड। फिर से प्रयास करें।",
  "items_selected": "वस्तुएं चयनित",
  "job_categories": "नौकरी श्रेणियां",
  "job_postings": "नौकरी पोस्टिंग्स",
  "job_seeker": "नौकरी चाहने वाला",
  "jobs": "नौकरियां",
  "just_now": "अभी-अभी",
  "language": "भाषा",
  "last": "अंतिम",
  "latest_news": "ताज़ा खबर",
  "legal": "कानूनी",
  "lifestyle": "जीवनशैली",
  "lifetime": "आजीवन",
  "light_mode": "लाइट मोड",
  "linked_email_campaign": "ईमेल अभियान से जुड़ा",
  "linkedin": "लिंक्डइन",
  "live_stream": "लाइव स्ट्रीम",
  "load_more": "और लोड करें",
  "loading": "लोड हो रहा है...",
  "local": "स्थानीय",
  "location": "स्थान",
  "login": "लॉगिन",
  "logout": "लॉगआउट",
  "loyalty_available_points": "उपलब्ध अंक",
  "loyalty_available_rewards": "उपलब्ध पुरस्कार",
  "loyalty_badges": "बैज",
  "loyalty_consecutive_days": "लगातार दिन",
  "loyalty_error": "त्रुटि",
  "loyalty_leaderboard": "लीडरबोर्ड",
  "loyalty_leaderboard_empty": "लीडरबोर्ड खाली है",
  "loyalty_rewards": "पुरस्कार",
  "loyalty_used_rewards": "उपयोग किए गए पुरस्कार",
  "majstor_categories": "श्रेणियाँ",
  "majstor_city": "शहर",
  "majstor_company_name": "कंपनी का नाम *",
  "majstor_flexible": "लचीला",
  "majstor_max_budget": "अधिकतम बजट (EUR)",
  "majstor_min_budget": "न्यूनतम बजट (EUR)",
  "majstor_my_requests": "मेरे अनुरोध",
  "majstor_request_title": "अनुरोध शीर्षक *",
  "majstor_service_categories": "सेवा श्रेणियाँ",
  "majstor_urgent": "तत्काल",
  "manage": "प्रबंधित करें",
  "manage_bookings": "विज्ञापनदाता बुकिंग प्रबंधित करें",
  "mark_as_read": "पढ़ा हुआ चिह्नित करें",
  "marketing_dashboard": "मार्केटिंग डैशबोर्ड",
  "marketing_live_metrics": "Croatia Times के लिए लाइव प्रदर्शन मेट्रिक्स",
  "marketing_published_articles": "प्रकाशित लेख",
  "marketing_registered_users": "पंजीकृत उपयोगकर्ता",
  "marketing_today_views": "आज के दृश्य",
  "marketing_total_views": "कुल पृष्ठ दृश्य",
  "minutes": "मिनट",
  "missing_translations": "अनुपस्थित अनुवाद",
  "mobile": "मोबाइल",
  "more": "और अधिक",
  "most_popular": "सबसे लोकप्रिय",
  "most_read": "सबसे अधिक पढ़ा",
  "move": "स्थानांतरित करें",
  "must_be_logged_in_purchase": "लेख खरीदने के लिए आपको लॉग इन होना चाहिए",
  "myProfile": "मेरा प्रोफ़ाइल",
  "my_applications": "मेरे आवेदन",
  "name": "नाम",
  "new": "नया",
  "new_article": "नया लेख",
  "new_campaign": "नया अभियान",
  "new_notification": "नई नोटिफिकेशन",
  "new_push_notification": "नया पुश नोटिफिकेशन",
  "new_verification_sent": "एक नया सत्यापन कोड आपके ईमेल पर भेजा गया है।",
  "news": "समाचार",
  "newsletter": "न्यूज़लेटर",
  "newsletter_desc": "नवीनतम समाचार के लिए सदस्यता लें",
  "newsletter_only_subscribers": "केवल ग्राहक",
  "newsletter_subscribers": "न्यूज़लेटर ग्राहक",
  "next": "अगला",
  "no": "नहीं",
  "noAccount": "कोई खाता नहीं है?",
  "no_articles": "कोई लेख नहीं मिला",
  "no_bookings": "कोई बुकिंग नहीं मिली",
  "no_campaigns": "कोई अभियान नहीं",
  "no_data": "कोई डेटा उपलब्ध नहीं",
  "no_items": "कोई आइटम नहीं मिला",
  "no_linked_campaign": "कोई संबद्ध अभियान नहीं",
  "no_notifications": "कोई सूचनाएं नहीं",
  "no_results": "कोई परिणाम नहीं",
  "no_scheduled_posts": "अभी तक कोई अनुसूचित पोस्ट नहीं",
  "no_sent_notifications": "कोई भेजी गई नोटिफिकेशन नहीं",
  "none": "कोई नहीं",
  "note": "नोट",
  "notification_body": "नोटिफिकेशन मुख्य भाग",
  "notification_title": "नोटिफिकेशन शीर्षक",
  "notifications": "सूचनाएं",
  "of": "का",
  "off": "बंद",
  "offline": "ऑफलाइन",
  "on": "चालू",
  "one_time": "एक बार",
  "online": "ऑनलाइन",
  "open_rate": "खुलने की दर",
  "optional": "वैकल्पिक",
  "options": "विकल्प",
  "orContinueWith": "या के साथ जारी रखें",
  "or_continue_with": "या जारी रखें",
  "order": "आदेश",
  "other": "अन्य",
  "page": "पृष्ठ",
  "part_time": "अंशकालिक",
  "password": "पासवर्ड",
  "paste": "चिपकाएँ",
  "pause": "रोकें",
  "payment_error": "भुगतान में त्रुटि",
  "payment_processing": "भुगतान संसाधित हो रहा है...",
  "payment_success": "भुगतान सफल!",
  "payment_thank_you": "आपकी खरीदारी के लिए धन्यवाद!",
  "pending": "लंबित",
  "pending_approval": "अनुमोदन लंबित",
  "per_month": "/माह",
  "per_page": "प्रति पृष्ठ",
  "percentage": "प्रतिशत",
  "performance": "प्रदर्शन",
  "phone": "फोन",
  "platforms": "प्लेटफ़ॉर्म",
  "politics": "राजनीति",
  "poll_results": "परिणाम",
  "poll_total_votes": "कुल वोट",
  "poll_vote": "वोट",
  "popular": "लोकप्रिय",
  "post_comment": "टिप्पणी पोस्ट करें",
  "post_error": "पोस्ट त्रुटि",
  "post_job": "नौकरी पोस्ट करें",
  "post_now": "अभी पोस्ट करें",
  "powered_by": "द्वारा संचालित",
  "premium": "प्रीमियम",
  "preview": "पूर्वावलोकन",
  "previous": "पिछला",
  "price": "मूल्य",
  "privacy": "गोपनीयता",
  "privacy_title": "गोपनीयता नीति",
  "proceed_to_payment": "भुगतान की प्रक्रिया जारी रखें",
  "profile": "प्रोफ़ाइल",
  "profile_admin_access": "प्रशासक त्वरित पहुँच",
  "profile_analytics": "विश्लेषिकी",
  "profile_articles": "लेख",
  "profile_dashboard": "डैशबोर्ड",
  "profile_edit": "प्रोफ़ाइल संपादित करें",
  "profile_verified": "प्रोफ़ाइल सत्यापित!",
  "promo_success": "प्रोमो कोड सफलतापूर्वक लागू किया गया!",
  "promote_job": "नौकरी का प्रचार करें",
  "publish": "प्रकाशित करें",
  "published": "प्रकाशित",
  "published_date": "प्रकाशित",
  "push_notifications": "पुश नोटिफिकेशन",
  "read": "पढ़ा गया",
  "read_more": "और पढ़ें",
  "real_estate": "रियल एस्टेट",
  "recent": "हाल ही में",
  "recipes_add_first": "अपनी पहली विधि जोड़ें",
  "recipes_browse_all": "सभी विधियाँ ब्राउज़ करें",
  "recipes_category": "श्रेणी",
  "recipes_cook_time": "पकाने का समय",
  "recipes_easy": "सरल",
  "recipes_featured": "विशेष विधियाँ",
  "recipes_filters": "फिल्टर",
  "recipes_ingredient": "सामग्री",
  "recipes_ingredients": "सामग्रियाँ",
  "recipes_instructions": "निर्देश",
  "recipes_latest": "नवीनतम विधियाँ",
  "recipes_most_popular": "सबसे लोकप्रिय विधियाँ",
  "recipes_prep_time": "तैयारी का समय",
  "recipes_search": "विधियाँ खोजें...",
  "recipes_servings": "परोसने की संख्या",
  "recipes_title": "विधियाँ",
  "recommended": "अनुशंसित",
  "refresh": "पुनः लोड करें",
  "region": "क्षेत्र",
  "register": "पंजीकरण",
  "reject": "अस्वीकार करें",
  "rejected": "अस्वीकृत",
  "related_articles": "संबंधित लेख",
  "remote": "रिमोट",
  "remove": "हटाएँ",
  "report": "रिपोर्ट",
  "reports": "रिपोर्ट्स",
  "reposting_rules_title": "पुनप्रेषण नियम",
  "required": "आवश्यक",
  "reset": "रीसेट",
  "restore": "बहाल करें",
  "results": "परिणाम",
  "resume": "फिर से शुरू करें",
  "revision_restored": "संशोधन बहाल!",
  "salary": "वेतन",
  "salary_max": "अधिकतम वेतन",
  "salary_min": "न्यूनतम वेतन",
  "save": "सहेजें",
  "saved_jobs": "सहेजी गई नौकरियां",
  "saved_successfully": "सफलतापूर्वक सहेजा गया",
  "schedule": "अनुसूची",
  "scheduled": "अनुसूचित",
  "science": "विज्ञान",
  "search": "खोजें...",
  "search_articles": "लेख खोजें...",
  "search_placeholder": "खोजें...",
  "search_results_for": "के लिए खोज परिणाम",
  "seconds": "सेकेंड",
  "see_all": "सभी देखें",
  "select": "चयन करें",
  "select_all": "सभी का चयन करें",
  "select_format": "प्रारूप चुनें",
  "seller": "विक्रेता",
  "send_campaign": "अभियान भेजें",
  "sent": "भेजा गया",
  "sent_campaigns": "भेजे गए अभियान",
  "services": "सेवाएँ",
  "settings": "समायोजन",
  "share": "शेयर",
  "showing": "दिखा रहा है",
  "signIn": "साइन इन",
  "signOut": "साइन आउट",
  "site_name": "Croatia Times",
  "site_subtitle": "क्रोएशिया आज",
  "six_digit_code": "6-अंकीय कोड",
  "social_media": "सोशल मीडिया",
  "social_scheduler": "सोशल शेड्यूलर",
  "sort": "सॉर्ट",
  "sponsored_marketplace_title": "प्रायोजित मार्केटप्लेस",
  "sports": "खेल",
  "stable": "स्थिर",
  "start": "प्रारंभ करें",
  "start_date": "प्रारंभ तिथि",
  "static_about_contact": "संपादकीय पूछताछ, विज्ञापन या सामान्य जानकारी के लिए, हमारे",
  "static_about_contact_page": "संपर्क पृष्ठ",
  "static_about_contact_title": "संपर्क करें",
  "static_about_lead": "Croatia Times एक स्वतंत्र समाचार पोर्टल है जो आपको क्रोएशिया और क्षेत्र से नवीनतम समाचार, विश्लेषण, टिप्पणी और कहानियाँ लाता है। हम e-mina.eu मीडिया परिवार का हिस्सा हैं, जिसमें वही टीम और वही मूल्य हैं।",
  "static_about_mission": "हम समय पर, गुणवत्ता और सटीक पत्रकारिता प्रदान करने के लिए प्रतिबद्ध हैं जो जनता के हित में काम करती है। हमारी संपादकीय टीम अनुभवी पत्रकारों से बनी है जो क्रोएशियाई और क्षेत्रीय मामलों का गहरा ज्ञान रखते हैं।",
  "static_about_mission_title": "हमारा मिशन",
  "static_about_publisher": "Liber Nostra d.o.o. Croatia Times और e-mina.eu का प्रकाशक है। कंपनी डिजिटल मीडिया और समाचार पोर्टल्स में विशेषज्ञता रखती है, जिसमें क्रोएशियाई बाजार पर ध्यान केंद्रित किया गया है।",
  "static_about_publisher_title": "प्रकाशक",
  "static_about_standards": "Croatia Times उच्चतम पत्रकारिता मानकों का पालन करता है। हम अपनी रिपोर्ट्स की तथ्य-जांच करते हैं, टिप्पणी और विश्लेषण को स्पष्ट रूप से लेबल करते हैं, और त्रुटियों को शीघ्रता और पारदर्शिता से सुधारते हैं।",
  "static_about_standards_title": "संपादकीय मानक",
  "static_about_team": "Croatia Times के पीछे एक टीम है जो अनुभवी मीडिया पेशेवरों, पत्रकारों, संपादकों और तकनीकी विशेषज्ञों से बनी है जो प्लेटफ़ॉर्म विकास और सामग्री की गुणवत्ता पर काम करते हैं। हमारी टीम वही है जो सफल पोर्टल e-mina.eu - International News Agency के पीछे खड़ी है।",
  "static_about_team_title": "टीम",
  "static_about_title": "हमारे बारे में - Croatia Times",
  "static_bug_description": "बग विवरण",
  "static_bug_description_placeholder": "क्या हुआ और समस्या को कैसे पुनरुत्पादित करना है, का वर्णन करें...",
  "static_bug_intro": "कुछ ऐसा मिला जो सही से काम नहीं कर रहा है? हमें बताएं और हम इसे तुरंत ठीक करेंगे।",
  "static_bug_page_url": "पृष्ठ URL (जहां बग हुई)",
  "static_bug_screenshot": "स्क्रीनशॉट (वैकल्पिक)",
  "static_bug_submit": "बग रिपोर्ट जमा करें",
  "static_bug_submitting": "जमा किया जा रहा है...",
  "static_bug_thanks": "आपकी रिपोर्ट के लिए धन्यवाद! हम इस मुद्दे की जांच करेंगे और इसे सुधारेंगे।",
  "static_bug_title": "बग रिपोर्ट करें",
  "static_commenting_intro": "हम रचनात्मक चर्चा का स्वागत करते हैं। हमारी टिप्पणी अनुभाग को सकारात्मक और उत्पादक बनाए रखने के लिए, कृपया इन नियमों का पालन करें:",
  "static_commenting_login": "टिप्पणी करने के लिए, आपको Croatia Times पर पंजीकृत और लॉग इन होना चाहिए।",
  "static_commenting_rule_1": "अन्य उपयोगकर्ताओं और लेखों के विषय के प्रति सम्मानजनक और शिष्ट रहें",
  "static_commenting_rule_2": "कोई घृणास्पद भाषण, नस्लवाद, लिंग भेदभाव, या किसी प्रकार का भेदभाव नहीं",
  "static_commenting_rule_3": "कोई स्पैम, विज्ञापन, या प्रचार सामग्री नहीं",
  "static_commenting_rule_4": "कोई गलत जानकारी या असत्यापित दावे नहीं फैलाना",
  "static_commenting_rule_5": "कोई व्यक्तिगत हमले या उत्पीड़न नहीं",
  "static_commenting_rule_6": "विषय पर बने रहें और वार्तालाप में योगदान करें",
  "static_commenting_rule_7": "तीसरे पक्ष के बारे में कोई व्यक्तिगत या गोपनीय जानकारी नहीं",
  "static_commenting_title": "टिप्पणी करने के नियम",
  "static_commenting_violation": "इन नियमों का उल्लंघन करने वाली टिप्पणियाँ बिना चेतावनी के हटाई जा सकती हैं। बार-बार उल्लंघन करने वालों को स्थायी रूप से प्रतिबंधित किया जा सकता है।",
  "static_contact_email": "ईमेल",
  "static_contact_message": "संदेश",
  "static_contact_message_placeholder": "आपका संदेश...",
  "static_contact_name": "नाम",
  "static_contact_name_placeholder": "आपका नाम",
  "static_contact_send": "संदेश भेजें",
  "static_contact_sending": "भेजा जा रहा है...",
  "static_contact_sent_desc": "हम 24 घंटे के भीतर आपको उत्तर देंगे।",
  "static_contact_sent_title": "संदेश भेजा गया!",
  "static_contact_subject": "विषय",
  "static_contact_subject_placeholder": "हम आपकी कैसे सहायता कर सकते हैं?",
  "static_contact_title": "हमसे संपर्क करें",
  "static_cookies_advertising_text": "हम प्रासंगिक विज्ञापन देने के लिए Google AdSense कुकीज़ का उपयोग कर सकते हैं।",
  "static_cookies_advertising_title": "विज्ञापन कुकीज़",
  "static_cookies_analytics_text": "Google Analytics हमें यह समझने में मदद करता है कि दर्शक हमारी साइट का उपयोग कैसे करते हैं। डेटा को संभावित रूप से गुमनाम किया जाता है।",
  "static_cookies_analytics_title": "विश्लेषिकी कुकीज़",
  "static_cookies_managing_text": "आप अपने ब्राउज़र सेटिंग्स के माध्यम से कुकीज़ को नियंत्रित कर सकते हैं। आवश्यक कुकीज़ को अक्षम करने से साइट कार्यक्षमता प्रभावित हो सकती है।",
  "static_cookies_managing_title": "कुकीज़ प्रबंधित करना",
  "static_cookies_necessary_text": "ये साइट को कार्य करने के लिए आवश्यक हैं (लॉगिन सत्र, थीम प्राथमिकताएं)। इन्हें अक्षम नहीं किया जा सकता।",
  "static_cookies_necessary_title": "आवश्यक कुकीज़",
  "static_cookies_title": "कुकी पॉलिसी",
  "static_cookies_types_title": "हमारे द्वारा उपयोग की जाने वाली कुकीज़ के प्रकार",
  "static_cookies_what_text": "कुकीज़ छोटे पाठ फाइलें होती हैं जिन्हें आपके डिवाइस पर तब डाला जाता है जब आप किसी वेबसाइट पर जाते हैं। वे साइट को आपकी प्राथमिकताओं को याद रखने और यह समझने में मदद करते हैं कि आप इसे कैसे उपयोग कर रहे हैं।",
  "static_cookies_what_title": "कुकीज़ क्या हैं",
  "static_imprint_ads_email": "ईमेल (विज्ञापन):",
  "static_imprint_ai_notice": "कुछ सामग्री AI प्रौद्योगिकी का उपयोग करके उत्पन्न की गई है। त्रुटियों या अनुचित सामग्री की रिपोर्ट करने के लिए",
  "static_imprint_contact": "संपर्क करें",
  "static_imprint_copyright": "कॉपीराइट",
  "static_imprint_copyright_text": "Croatia Times पर प्रकाशित सभी सामग्री कॉपीराइट द्वारा संरक्षित है। Liber Nostra d.o.o. इस साइट पर प्रकाशित पाठ, छवियों और मल्टीमीडिया सामग्री पर सभी अधिकार रखता है। सामग्री पुनः पोस्टिंग के नियमों के बारे में विस्तृत जानकारी के लिए देखें",
  "static_imprint_ct_desc": "Croatia Times समाचार पोर्टल",
  "static_imprint_disclaimer": "अस्वीकरण",
  "static_imprint_disclaimer_text": "सावधानीपूर्वक सामग्री नियंत्रण के बावजूद, हम बाहरी कड़ियों के लिए कोई जिम्मेदारी नहीं लेते हैं। उनके ऑपरेटर उनके सामग्री के लिए पूरी तरह जिम्मेदार हैं।",
  "static_imprint_editorial_email": "ईमेल (संपादकीय):",
  "static_imprint_emina_desc": "अंतर्राष्ट्रीय समाचार एजेंसी",
  "static_imprint_general_email": "ईमेल (सामान्य पूछताछ):",
  "static_imprint_last_updated": "अंतिम अपडेट: फरवरी 2026",
  "static_imprint_or_via": "या हमारे जरिए",
  "static_imprint_publisher": "प्रकाशक",
  "static_imprint_registered": "क्रोएशिया गणराज्य में पंजीकृत",
  "static_imprint_reposting_page": "पुनः पोस्टिंग नियम पृष्ठ",
  "static_imprint_responsible": "सामग्री के लिए जिम्मेदार",
  "static_imprint_responsible_text": "Croatia Times / Liber Nostra d.o.o. की संपादकीय टीम",
  "static_imprint_title": "इम्प्रिंट",
  "static_imprint_websites": "वेबसाइट्स",
  "static_privacy_controller": "डेटा नियंत्रक: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "हम कार्यक्षमता और विश्लेषिकी के लिए कुकीज़ का उपयोग करते हैं। विवरण के लिए हमारी कुकी पॉलिसी देखें।",
  "static_privacy_cookies_title": "कुकीज़",
  "static_privacy_data_text": "हम वह डेटा संग्रह करते हैं जो आप सीधे प्रदान करते हैं (नाम, साइन अप करते समय ईमेल), उपयोग डेटा (पृष्ठों का दौरा, पढ़े गए लेख) और तकनीकी डेटा (आईपी पता, ब्राउज़र प्रकार)।",
  "static_privacy_data_title": "हम कौन सा डेटा संग्रह करते हैं",
  "static_privacy_last_updated": "अंतिम अपडेट: जनवरी 2026",
  "static_privacy_lead": "Croatia Times आपकी गोपनीयता का सम्मान करता है और आपके व्यक्तिगत डेटा की सुरक्षा के लिए प्रतिबद्ध है।",
  "static_privacy_retention_text": "हम आपके डेटा को तब तक बनाए रखते हैं जब तक आपका खाता सक्रिय है, या कानूनी उद्देश्यों के लिए आवश्यक है।",
  "static_privacy_retention_title": "डेटा प्रतिधारण",
  "static_privacy_rights_text": "आपको अपने व्यक्तिगत डेटा तक पहुंच, सही करने या हटाने का अधिकार है। हमसे संपर्क करें",
  "static_privacy_rights_title": "आपके अधिकार",
  "static_privacy_title": "गोपनीयता नीति",
  "static_privacy_usage_text": "हम आपके डेटा का उपयोग हमारी समाचार सेवा प्रदान करने के लिए, आपके अनुभव को वैयक्तिकृत करने के लिए, न्यूज़लेटर्स भेजने के लिए (आपकी सहमति के साथ), और हमारे प्लेटफ़ॉर्म को बेहतर बनाने के लिए करते हैं।",
  "static_privacy_usage_title": "हम आपके डेटा का उपयोग कैसे करते हैं",
  "static_reposting_copyright_text": "Croatia Times पर प्रकाशित सभी सामग्री कॉपीराइट द्वारा संरक्षित है। Liber Nostra d.o.o. इस वेबसाइट पर प्रकाशित टेक्स्ट, छवियों, और मल्टीमीडिया के सभी अधिकार सुरक्षित रखता है।",
  "static_reposting_copyright_title": "कॉपीराइट",
  "static_reposting_permission_text": "सामग्री को पुनर्मुद्रण करने की अनुमति के लिए, हमसे संपर्क करें",
  "static_reposting_permission_title": "अनुमति अनुरोध",
  "static_reposting_permitted_text": "आप हमारे लेखों के लिंक को सोशल मीडिया और अन्य प्लेटफार्मों पर साझा कर सकते हैं। स्वतंत्र रूप से (2 पैरा तक) उद्धरण स्पष्ट श्रेय और मूल लेख के लिंक के साथ उपयोग किए जा सकते हैं।",
  "static_reposting_permitted_title": "अनुमत उपयोग",
  "static_reposting_prohibited_text": "लेखों का पूर्ण पुनर्मुद्रण बिना लिखित अनुमति के निषिद्ध है। छवियों की पुनरुत्पत्ति बिना अनुमति के नहीं की जा सकती। सामग्री की स्वचालित स्क्रैपिंग सख्ती से मना है।",
  "static_reposting_prohibited_title": "निषिद्ध उपयोग",
  "static_reposting_title": "पुनःप्रकाशन नियम",
  "static_submit_news_details": "कहानी का विवरण",
  "static_submit_news_details_placeholder": "खबर का वर्णन करें...",
  "static_submit_news_file_limit_error": "फ़ाइल सीमा से अधिक है",
  "static_submit_news_headline": "समाचार शीर्षक",
  "static_submit_news_intro": "क्या आपके पास कोई खबर है? इसे यहाँ भेजें और हमारी संपादकीय टीम इसकी समीक्षा करेगी।",
  "static_submit_news_limit": "हम फ़ोटो और वीडियो को स्वीकार करते हैं",
  "static_submit_news_photos": "फोटो / वीडियो (अधिकतम",
  "static_submit_news_send": "समाचार जमा करें",
  "static_submit_news_sending": "भेजा जा रहा है...",
  "static_submit_news_source": "स्रोत / संदर्भ (वैकल्पिक)",
  "static_submit_news_source_placeholder": "URL या संदर्भ",
  "static_submit_news_thanks": "आपके सबमिशन के लिए धन्यवाद! हमारी टीम जल्द ही इसकी समीक्षा करेगी।",
  "static_submit_news_title": "अपनी खबर सबमिट करें",
  "static_submit_news_your_name": "आपका नाम",
  "status": "स्थिति",
  "stop": "रोकें",
  "submit": "प्रस्तुत करें",
  "submitNews": "समाचार जमा करें",
  "submit_bug_title": "बग रिपोर्ट जमा करें",
  "submit_news": "समाचार भेजें",
  "submit_news_title": "समाचार प्रस्तुत करें",
  "subscribe": "सदस्यता लें",
  "subscription": "सदस्यता",
  "subscription_title": "सदस्यता योजनाएँ",
  "success": "सफलता",
  "support": "समर्थन",
  "tablet": "टैबलेट",
  "tags": "टैग",
  "target_impressions": "लक्ष्य इंप्रेशन",
  "technology": "प्रौद्योगिकी",
  "template": "टेम्पलेट",
  "templates": "टेम्पलेट्स",
  "terms": "शर्तें",
  "thank_you": "धन्यवाद",
  "this_month": "इस माह",
  "this_week": "इस सप्ताह",
  "this_year": "इस वर्ष",
  "tip": "सुझाव",
  "title": "शीर्षक",
  "to": "तक",
  "today": "आज",
  "total": "कुल",
  "translate_all": "सभी अनुवाद करें",
  "translation_status": "अनुवाद स्थिति",
  "translations": "अनुवाद",
  "travel": "यात्रा",
  "trending": "प्रचलित",
  "try_again": "पुनः प्रयास करें",
  "twitter": "ट्विटर",
  "two_factor_auth": "द्वि-घटक प्रमाणीकरण",
  "type": "प्रकार",
  "ugc_submit": "सामग्री सबमिट करें",
  "ugc_title": "नागरिक पत्रकारिता पोर्टल",
  "unique_clicks": "अद्वितीय क्लिक",
  "unique_opens": "अद्वितीय खुलने की संख्या",
  "unknown": "अज्ञात",
  "unpublish": "अप्रकाशित करें",
  "unread": "अपठित",
  "update": "अपडेट",
  "updated_successfully": "सफलतापूर्वक अपडेट किया गया",
  "upgrade": "अपग्रेड",
  "upload": "अपलोड",
  "users": "उपयोगकर्ता",
  "vehicles": "वाहन",
  "verification_code_sent": "सत्यापन कोड आपके ईमेल पर भेजा गया है!",
  "version": "संस्करण",
  "vibeposao": "Times Posao",
  "view": "देखें",
  "view_all": "सभी देखें",
  "views": "व्यूज",
  "warning": "चेतावनी",
  "welcome": "स्वागत है",
  "wish_roles": "इच्छित भूमिकाएं",
  "working_hours_saved": "काम के घंटे सहेजे गए!",
  "world": "विश्व",
  "write_new_article": "नया लेख लिखें",
  "yes": "हाँ",
  "yesterday": "कल",
  "your_bookings": "आपकी बुकिंग",
  "youtube": "यूट्यूब"
}
